import { useState, memo } from "react";
import classNames from "classnames";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, useReactFlow } from "reactflow";
import StepSelectionDialogButton from "layouts/Flow Designer/components/StepSelectionDialog";
import { NODE_TYPES } from "constants/flowDesigner";

import "./css/index.css";

const ButtonEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  target,
  source
}) => {
  const { getNode } = useReactFlow();
  const [active, setActive] = useState(false);
  const isHiddedNode = getNode(target)?.type === NODE_TYPES.HIDDEN;
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  const divClass = classNames({
    nodrag: true,
    nopan: true,
    active: active
  });

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={isHiddedNode ? "default" : markerEnd}
        type="smoothstep"
        style={style}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            // everything inside EdgeLabelRenderer has no pointer events by default
            // if you have an interactive element, set pointer-events: all
            pointerEvents: "all"
          }}
          className={divClass}
        >
          <StepSelectionDialogButton source={source} target={target} setActive={setActive} />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default memo(ButtonEdge);
